<template>
  <span>
    <b-button :disabled="!deck" @click="show">Export</b-button>
    <b-modal
      v-if="deck"
      title="Export deck"
      v-model="showModal"
      size="xl"
      ok-only
    >
      <b-tabs v-model="exportTabIndex" content-class="m-3">
        <b-tab title="JSON">
          <b-form-textarea
            readonly
            :value="JSON.stringify(deck, null, 2)"
            rows="15"
          >
          </b-form-textarea>
        </b-tab>
        <b-tab v-if="versionID" lazy title="TTS JSON">
          <TTSExport :deck="deck" :name="name" :versionID="versionID" />
        </b-tab>
        <b-tab title="HUmN (Deprecated)">
          <b-alert variant="danger" show>
            <h4>Deprecation warning</h4>
            <p>
              The HUmN specification hasn't kept up as features have been added
              to Unmatched Maker, so it no longer captures all of the data about
              the deck.
            </p>
            <p>
              If you want to save your deck, JSON is recommended.
            </p>
          </b-alert>
          <b-form-textarea readonly :value="humanDeck" rows="15">
          </b-form-textarea>
        </b-tab>
        <b-tab title="Spreadsheet">
          <p>
            For exporting decks to the
            <a
              href="https://docs.google.com/spreadsheets/d/1qt_d1ZvIrPbDM4AcIuSCYywXaKDW-FqrMH4wnU-vqNQ/copy?usp=sharing"
              target="_blank"
              >Google Sheet</a
            >
            for the
            <a
              href="https://restorationgames.com/unmatched/unmatched-design-contest/"
              target="_blank"
              >Fan Deck Contest</a
            >.
          </p>
          <b-form-group
            label="Hero Power"
            description="Paste this row in the 'Hero Power' tab."
          >
            <b-form-textarea rows="4" readonly :value="spreadsheetHero">
            </b-form-textarea>
          </b-form-group>
          <b-form-group
            label="Card List"
            description="Paste these rows in the 'Card List' tab."
          >
            <b-form-textarea rows="15" readonly :value="spreadsheetCards">
            </b-form-textarea>
          </b-form-group>
        </b-tab>
      </b-tabs>
    </b-modal>
  </span>
</template>

<script>
import serializeToHuman from "@/parser/serializer.js";

import TTSExport from "@/components/TTSExport.vue";

export default {
  name: "ExportDeck",
  props: ["deck", "name", "note", "versionID"],
  components: { TTSExport },
  data() {
    return {
      showModal: false
    };
  },
  computed: {
    exportTabIndex: {
      get() {
        if ("exportTabIndex" in this.$store.state.userPreferences) {
          return this.$store.state.userPreferences.exportTabIndex;
        }
        return 0;
      },
      set(value) {
        this.$store.commit("setPreference", {
          key: "exportTabIndex",
          value: value
        });
      }
    },
    humanDeck() {
      return this.deck ? serializeToHuman(this.deck) : "";
    },
    spreadsheetCards() {
      const outputArray = [];
      const deckName = this.name || this.deck.hero.name;
      const copiesFormula =
        '=COUNTA(FILTER(B:B,B:B=INDIRECT(CONCATENATE("B",ROW())),C:C=INDIRECT(CONCATENATE("C",ROW()))))';
      const lineFormula =
        '=if(len(INDIRECT(CONCATENATE("I",ROW()))),"line.jpg",)';
      this.deck.cards.forEach(card => {
        const valueString = this.getValueString(card.type, card.value);
        const effectString = this.getEffectString(card);
        const outputLine = `${deckName}\t${card.characterName.trim()}\t${card.title.trim()}\t${
          card.boost
        }\t${valueString}\t${effectString.trim()}\t${copiesFormula}\t${lineFormula}`;
        outputArray.push(...Array(card.quantity).fill(outputLine));
      });

      return outputArray.join("\n");
    },
    spreadsheetHero() {
      const hero = this.deck.hero;
      const sidekick = this.deck.sidekick;
      return `${hero.name}\t${hero.move}\t${hero.hp}\t${
        hero.isRanged ? "Ranged" : "Melee"
      }\t${hero.specialAbility}\t${sidekick.name}\t${sidekick.hp}\t${
        sidekick.quantity
      }x\t${sidekick.isRanged ? "Ranged" : "Melee"}\t${this.note}`;
    }
  },
  methods: {
    show() {
      this.showModal = true;
    },
    getValueString(type, value) {
      const cardTypeFormula =
        '=iferror(INDEX({"icon_Versatile.ai","icon_Attack.ai","icon_Defense.ai"},1, MATCH(JOIN("",INDIRECT(CONCATENATE("E",ROW(),":G",ROW()))),INDIRECT(CONCATENATE("E",ROW(),":G",ROW())),0)),"icon_Scheme.ai")';
      switch (type) {
        case "versatile":
          return `${value}\t\t\t${cardTypeFormula}`;
        case "attack":
          return `\t${value}\t\t${cardTypeFormula}`;
        case "defence":
          return `\t\t${value}\t${cardTypeFormula}`;
        default:
          return `\t\t\t${cardTypeFormula}`;
      }
    },
    getEffectString(card) {
      const effects = [];
      if (card.basicText) {
        effects.push(card.basicText);
      }
      if (card.immediateText) {
        effects.push(`Immediately:${card.immediateText}`);
      }
      if (card.duringText) {
        effects.push(`During Combat:${card.duringText}`);
      }
      if (card.afterText) {
        effects.push(`After Combat:${card.afterText}`);
      }
      // Escape quotes for TSV
      var effectString = effects.join("\n");
      effectString = effectString.replace(/"/g, '""');
      return `"${effectString}"`;
    }
  }
};
</script>

<style lang="less" scoped>
textarea {
  width: 100%;
  font-family: monospace;
}
</style>
